// src/routes/CertificationsPage.js
import React from "react";
import Navbar from "../components/Navbar";
import PageHero from "../components/PageHero";
import Certificates from "../components/Certificates";
import Footer from "../components/Footer";

const CertificationsPage = () => (
  <div>
    <Navbar />
    <PageHero
      label="Credentials"
      heading="Certifications."
      sub="Continuous learning is at the core of everything I do."
    />
    <Certificates title="All Certifications" />
    <Footer />
  </div>
);

export default CertificationsPage;
